// bet acc reg
export const betAccReg = /^\d{8}$/i;
export const PinReg = /^\d{6}$/i;
export const updatePasswordReg = {
    wcipChange: new RegExp("^/[^/]+/change$"),
    wcipForgot: new RegExp("^/[^/]+/forgot$"),
    wcipAssociate: new RegExp("^/[^/]+/associate$"),
    csspChange: new RegExp("^/[^/]+/change/cssp$"),
    csspForgot: new RegExp("^/[^/]+/forgot/cssp$"),
    csspAssociate: new RegExp("^/[^/]+/associate/cssp$"),
    mobileAppChange: new RegExp("^/[^/]+/change/mobileApp$"),
    mobileAppForgot: new RegExp("^/[^/]+/forgot/mobileApp$"),
    memberChange: new RegExp("^/[^/]+/change/member$"),
    memberForgot: new RegExp("^/[^/]+/forgot/member$"),
    wcipProfile: new RegExp("^/[^/]+/profile-maintenance$"),
    mobileAppAssociate: new RegExp("^/[^/]+/associate/mobileApp$"),
};

export const emailReg = new RegExp(
    "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,}$"
);

export const validateHKID = (hkid) => {
    // 移除空格和转换为大写
    const cleanedHKID = hkid.replace(/\s/g, "").toUpperCase();

    // 基础格式验证
    const basicRegex = /^[A-Z]{1,2}\d{6}(\([0-9A]\))?$/;
    if (!basicRegex.test(cleanedHKID)) {
        return false;
    }

    // 提取主要部分和校验码
    let mainPart, checkDigit;

    if (cleanedHKID.includes("(")) {
        mainPart = cleanedHKID.split("(")[0];
        checkDigit = cleanedHKID.match(/\(([0-9A])\)/)[1];
    } else if (cleanedHKID.length === 8) {
        mainPart = cleanedHKID.substring(0, 7);
        checkDigit = cleanedHKID.charAt(7);
    } else if (cleanedHKID.length === 9) {
        mainPart = cleanedHKID.substring(0, 8);
        checkDigit = cleanedHKID.charAt(8);
    } else {
        return false;
    }

    // 校验码验证算法
    return validateCheckDigit(mainPart, checkDigit);
};

function validateCheckDigit(mainPart, checkDigit) {
    // 香港身份证校验算法
    const str = mainPart.padStart(8, " "); // 确保长度为8位
    let sum = 0;

    for (let i = 0; i < 8; i++) {
        const char = str.charAt(i);
        let value;

        if (char >= "0" && char <= "9") {
            value = parseInt(char, 10);
        } else if (char >= "A" && char <= "Z") {
            value = char.charCodeAt(0) - 55; // A=10, B=11, ..., Z=35
        } else {
            value = 36; // 空格
        }

        sum += value * (9 - i);
    }

    const remainder = sum % 11;
    let expectedCheckDigit;

    if (remainder === 0) {
        expectedCheckDigit = "0";
    } else if (remainder === 1) {
        expectedCheckDigit = "A";
    } else {
        expectedCheckDigit = (11 - remainder).toString();
    }

    return checkDigit === expectedCheckDigit;
}
